import ReactDOM from 'react-dom/client';
import { installStaleChunkReload } from '@/utils/chunk-reload';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import 'flag-icons/css/flag-icons.min.css';
import './index.css';
import './i18n';
import App from './App';
import { AppThemeProvider } from './theme';

// Suppress benign ResizeObserver browser warning that CRA surfaces as an error overlay
const _resizeObserverErr = window.onerror;
window.onerror = (msg, ...args) => {
	if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true;
	return _resizeObserverErr ? (_resizeObserverErr(msg, ...args) as boolean) : false;
};

installStaleChunkReload();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
	// Erorile „recuperate" de React (re-randare sincronă după un throw în randarea
	// concurentă) apar în producție doar ca #520, fără cauză. Logăm explicit excepția
	// originală + component stack-ul, ca rapoartele de pe instruire să fie acționabile.
	onRecoverableError: (error, errorInfo) => {
		console.error(
			'[react-recoverable]',
			error,
			errorInfo?.componentStack ?? '(fără component stack)'
		);
	}
});
root.render(
	// <React.StrictMode>
	<AppThemeProvider>
		<App />
	</AppThemeProvider>
	// </React.StrictMode>,
);
